import { Component } from '@angular/core';

import { MatExpansionModule } from '@angular/material/expansion';

@Component({
    selector: 'app-faq',
    imports: [MatExpansionModule],
    templateUrl: './faq.component.html',
    styleUrls: ['./faq.component.scss']
})
export class FaqComponent {
}
